import React from 'react';
import { getStatusIcon } from '../../../util/statusIndicatorUtil';
import SortableTable from '../../atoms/SortableTable';

export const StatusIndicator = data => {
  const {
    data: { status },
  } = data;
  return getStatusIcon(status);
};

const ExpanderRowContent = ({ metrics }) => {
  const columns = [
    { header: 'Template name', accessor: 'templateName', sortID: 'templateName' },
    { header: 'Segment name', accessor: 'segmentName', sortID: 'segmentName' },
    { header: 'Last modified', accessor: 'lastModifiedDate', sortID: 'lastModifiedDate' },
    {
      header: 'Total delivered',
      accessor: 'uniqueDeliveries',
      sortID: 'uniqueDeliveries',
      default: '-',
    },
    { header: 'Open Rate', accessor: 'openRate', sortID: 'openRate', default: '-' },
    { header: 'Status', cellComponent: StatusIndicator },
  ];
  return <SortableTable columns={columns} defaultActiveSortId={'segmentName'} data={metrics} />;
};

export default ExpanderRowContent;
